module.exports = __webpack_public_path__ + "img/border5.49678407.png";